import axios, { AxiosPromise } from "axios";
import * as qs from "qs";

export class NetworkService {
  public static get<T = any>(
    url: string,
    query?: any,
    headers?: { [key: string]: string }
  ) {
    let urlWithParams = url;
    if (query) {
      const queryString = qs.stringify(query);
      urlWithParams = `${url}?${queryString}`;
    }
    return this.parseAxiosRequest<T>(axios.get(urlWithParams, { headers }));
  }

  public static post<T = any>(url: string, body: any) {
    return this.parseAxiosRequest<T>(axios.post(url, body));
  }

  public static authenticatedGet<T = any>(url: string, token: string) {
    const headers = {
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    return this.parseAxiosRequest<T>(
      axios.get(url, headers)
    );
  }

  public static authenticatedPost<T = any>(
    url: string,
    body: any,
    token: string
  ) {
    return this.parseAxiosRequest<T>(
      axios.post(url, body, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
    );
  }

  private static async parseAxiosRequest<T>(
    request: AxiosPromise<T>
  ): Promise<T> {
    const data = await request;
    if (!data || data.status !== 200 || !data.data) {
      throw new Error(`Bad status ${JSON.stringify(data)}`);
    } else {
      return data.data;
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/Network/NetworkService.ts